/** @file frameScratch: the per-instance buffers one frame writes (pose, picks, impostor list, events). */
import type { FacetPick } from '@zilo/pose3d-facet/contract';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import type { PoseBuffer } from '@zilo/pose3d-pose/contract';
import type { EventReport, FiredEvent } from '@zilo/pose3d-pose/events/eventTypes';
import { POSE_LAYOUT } from '@zilo/pose3d-pose/layout/poseLayout';
import type { ImpostorList } from '@zilo/pose3d-render-core/contract';
import { IMPOSTOR_LAYOUT } from '@zilo/pose3d-render-core/layout/impostorLayout';

/** Buffers reused every frame. */
export type FrameScratch = { pose: PoseBuffer; picks: FacetPick[]; list: ImpostorList; fired: FiredEvent[]; reports: EventReport[] };

/** `pose` = nodes x `POSE_LAYOUT.stride`; `list` = (impostors + effects) x `IMPOSTOR_LAYOUT.stride`. */
export function frameScratch(puppet: Puppet): FrameScratch {
  const quads = puppet.drawables.filter((d) => d.kind === 'impostor' || d.kind === 'effect').length;
  return {
    pose: new Float64Array(Object.keys(puppet.nodes).length * POSE_LAYOUT.stride), picks: [],
    list: new Float64Array(Math.max(1, quads) * IMPOSTOR_LAYOUT.stride), fired: [], reports: [],
  };
}
